export const getNextIndexByStep = (currentIndex: number, length: number, step: 1 | -1): number => {
  if (currentIndex < 0) {
    return step === 1 ? 0 : length - 1;
  }

  return (currentIndex + step + length) % length;
};

export const getNextCyclicIndex = (currentIndex: number, length: number): number =>
  getNextIndexByStep(currentIndex, length, 1);

export const selectNextMatchingOption = <T>(matchingOptions: T[], currentIndex: number, isCycling: boolean): T => {
  if (!isCycling) return matchingOptions[0];

  const nextIndex = getNextCyclicIndex(currentIndex, matchingOptions.length);
  return matchingOptions[nextIndex];
};

/**
 * Scrolls the option element into the visible area of its scrollable container.
 * Uses `block: "nearest"` so that already-visible items are not repositioned.
 */
export const scrollActiveOptionIntoView = (optionId: string | undefined): void => {
  if (!optionId) return;
  const element = document.getElementById(optionId);
  element?.scrollIntoView({ block: "nearest" });
};
